import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
  permission?: string; // Changed from roles: string[] to permission: string
}

const PrivateRoute = ({ children, permission }: PrivateRouteProps) => { // Changed roles to permission
  const { user, loading, can } = useAuth(); // Changed isAllowed to can
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    console.log('PrivateRoute: Redirecting to login, saving original path:', location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If a permission is required and the user doesn't have it, redirect.
  if (permission && !can(permission)) {
    // Consider redirecting to an "Access Denied" page or a safe default like dashboard
    return <Navigate to="/dashboard" replace />; // Or potentially to an unauthorized page
  }

  // User is allowed, render the children components
  return <>{children}</>;
};

export default PrivateRoute;
